/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
     <br>
  <div>
  <div class="formPosition">

<!-- ============================ DIALOGO ITEMS DE VENDA =========================================-->
            <template>
  <v-row justify="center">
    <v-dialog v-model="dialog_items" persistent max-width="1000px">
      <v-card>
        <v-card-title style="background-color:#006699;color:white;" >
          <span class="headline">Items da Factura</span>
        </v-card-title>
        <v-card-text>

                              <v-data-table :search="search" :headers="headersItensVenda" :items="items_factura">
                                  <template v-slot:item.numeracao="{ item }">
                                    <span>{{items_factura.indexOf(item)+1}}</span>
                                  </template>
                                  <template v-slot:item.precoUnitario="{ item }">
                                          <span>{{utilitarios.IntegerToMoneyValue(item.precoUnitario)}}</span>
                                       </template>
                              </v-data-table>

                    </v-card-text>

         <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" class="white--text"   @click="dialog_items = false" col>Fechar</v-btn>
        </v-card-actions>
       </v-card>
     </v-dialog>
  </v-row>
  </template>

<!-- =============================================================================================-->

 <!-- =========================== DIALOGO DE DETALHES ============================================== -->
              <template>
  <v-row justify="center">
    <v-dialog v-model="dialog_detalhes" persistent max-width="1200px">
      <v-card>
        <v-card-title style="background-color:#006699;color:white;" >
          <span class="headline">Detalhes do Caixa</span>
        </v-card-title>
        <v-card-text>
          <v-container>
              <template>
                    <v-card>
                      <v-tabs
                        v-model="tab"
                        color="#006699"
                      >
                        <v-tab
                          v-for="item in tabsItems"
                          :key="item.tab"
                        >
                          {{ item.tab }}
                        </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="tab">
                        <v-tab-item
                        >
                          <v-card flat>
                            <v-card-text>
                              <v-container>
                                <v-row style="border:1px solid #cccccc">
                                   <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Descrição: </span><span style="font-size:15px;font-weight:bold;">{{editedItemCaixa.descricao}}</span>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Status: </span><span style="font-size:15px;font-weight:bold;">{{(!detalhes.length)?'Ainda não foi utilizado Hoje':((detalhes[0].fkOperacaoCaixa===1)?'Aberto':'Fechado')}}</span>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="12" v-if="detalhes.length">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Data Operação: </span><span style="font-size:15px;font-weight:bold;">{{detalhes[0].data_operacao}}</span>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="12" v-if="detalhes.length">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Utilizado por: </span><span style="font-size:15px;font-weight:bold;"> {{detalhes[0].nome_pessoa}}</span>
                                  </v-col>
                                   <v-col cols="12" sm="6" md="6" v-if="detalhes.length">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Montante de Abertura:</span><span style="font-size:15px;font-weight:bold;">{{utilitarios.IntegerToMoneyValue(detalhes[0].montanteAbertura)}}</span>
                                  </v-col>
                                   <v-col cols="12" sm="6" md="6" v-if="detalhes.length">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Montante de Enceramento:</span><span style="font-size:15px;font-weight:bold;">{{(detalhes[0].fkOperacaoCaixa === 2) ? utilitarios.IntegerToMoneyValue(detalhes[0].montanteFecho):''}}</span>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item
                        >
                          <v-card flat>
                            <v-card-text>
                              <v-container>
                                <v-row style="border:1px solid #cccccc">
                                  <v-col md="8"><h2>Movimentações</h2></v-col>
                                  <v-col md="4">
                                      <template>
                                        <v-menu
                                          ref="menuVencimento"
                                          v-model="menuVencimento"
                                          :close-on-content-click="false"
                                          transition="scale-transition"
                                          offset-y
                                          full-width
                                          min-width="290px"
                                        >
                                          <template v-slot:activator="{ on }">
                                            <v-text-field
                                            v-model="dataVencimento"
                                              label="Selecione uma data"
                                              prepend-icon="event"
                                              readonly
                                              v-on="on"
                                            ></v-text-field>
                                          </template>
                                          <v-date-picker
                                            v-model="dataFabrico"
                                            ref="picker"
                                            max="2025-12-31"
                                            min="1950-01-01"
                                            @change="saveDataVencimento"
                                          ></v-date-picker>
                                        </v-menu>
                                        </template>
                                  </v-col>
                                   <v-col cols="12" sm="6" md="12">
                                     <v-data-table :search="search" :headers="headersCaixa" :items="movimentacoes">
                                       <template v-slot:item.movimento="{ item }">
                                          <span>{{movimentacoes.indexOf(item)+1}}</span>
                                       </template>
                                       <template v-slot:item.valorAPagar="{ item }">
                                          <span>{{utilitarios.IntegerToMoneyValue(item.valorAPagar)}}</span>
                                       </template>
                                       <template v-slot:item.troco="{ item }">
                                          <span>{{utilitarios.IntegerToMoneyValue(item.troco)}}</span>
                                       </template>
                                       <template v-slot:item.valorPago="{ item }">
                                          <span>{{utilitarios.IntegerToMoneyValue(item.valorPago)}}</span>
                                       </template>
                                       <template v-slot:item.action="{ item }">
                                          <v-menu
                                            :offset-x="offsetX"
                                            :offset-y="offsetY"
                                            bottom
                                            origin="center center"
                                            transition="scale-transition"
                                          >
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-btn
                                                fab dark small
                                              color="#006699"
                                                v-bind="attrs"
                                                v-on="on"
                                              >
                                                <v-icon dark>menu</v-icon>
                                              </v-btn>
                                            </template>
                                            <v-list>
                                              <v-list-item  @click="VerItemsVenda(item)">
                                                <v-icon color="green">edit</v-icon>Ver Items da venda
                                              </v-list-item>
                                              <v-divider></v-divider>
                                              <v-list-item  @click="VerItemsVenda(item)">
                                                <v-icon color="green">list</v-icon>Ré-imprimir factura
                                              </v-list-item>
                                            </v-list>
                                          </v-menu>
                                      </template>
                                     </v-data-table>
                                   </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </template>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" class="white--text"   @click="dialog_detalhes = false" col>Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </template>
    <!-- ====================================================================================================== -->
      <v-card>
    <v-progress-linear
      v-if="progresso"
        indeterminate
        color="green"
        height="10"
      ></v-progress-linear>
      <v-card-title>
        <span>Caixas ou Mesas</span>
         <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
      </v-card-title>
        <template>
          <v-data-table :search="search" :headers="headers" :items="fornecedores">
            <template v-slot:item.status_aberto_fecho="{item}">
                  <span v-if="item.status_aberto_fecho===0">Não utilizado até o momento</span>
                  <span v-if="item.status_aberto_fecho===1">Caixa aberto</span>
                  <span v-if="item.status_aberto_fecho===2">Caixa Fechado</span>
            </template>
           <template v-slot:item.action="{ item }">
                  <v-menu
                    :offset-x="offsetX"
                    :offset-y="offsetY"
                    bottom
                    origin="center center"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab dark small
                       color="#006699"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark>menu</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item  @click="DetalhesCaixa(item)">
                        <v-icon color="green">edit</v-icon>Ver detalhes
                      </v-list-item>
                    </v-list>
                  </v-menu>
              </template>
          </v-data-table>
        </template>
      </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    offsetX: false,
    offsetY: true,
    alert: false,
    menuVencimento: null,
    iconAlert: '',
    alertType: '',
    dataVencimento: '',
    dataFabrico: null,
    tab: null,
    colorAlert: '',
    utilitarios: utilitarios,
    msgAlert: '',
    dialog_items: false,
    allowSpaces: false,
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    tabsItems:
    [
      { id: 1, tab: 'Geral' },
      { id: 2, tab: 'Actividades Recentes' }
    ],
    progresso: false,
    valid: true,
    dialog_detalhes: false,
    menu: false,
    headersItensVenda: [
      { text: 'Numeração', value: 'numeracao' },
      { text: 'Produto', value: 'produto' },
      { text: 'Qtd', value: 'qtd_venda' },
      { text: 'Preço unitário', value: 'precoUnitario' }
    ],
    fornecedores: [],
    items_factura: [],
    movimentacoes: [],
    detalhes: [],
    search: '',
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Descrição',
        align: 'start',
        sortable: false,
        value: 'descricao'
      },
      { text: 'Status', value: 'status_aberto_fecho' },
      { text: 'Action', value: 'action' }
    ],
    headersCaixa: [
      { text: 'Movimento', value: 'movimento' },
      { text: 'Documento', value: 'documento' },
      { text: 'Referência', value: 'numeroDocumento' },
      { text: 'Valor Pago', value: 'valorAPagar' },
      { text: 'Valor Entregue', value: 'valorPago' },
      { text: 'Troco', value: 'troco' },
      { text: 'Action', value: 'action' }
    ],
    msg: '',
    pkCaixa: '',
    editedItem: {
      email: '',
      morada: '',
      nif: '',
      nome: '',
      observacao: '',
      pkFornecedor: 0,
      telefone1: '',
      telefone2: '',
      tipoFornecedor: ''
    },
    tipoFornecedores:
    [
      { descricao: 'Muito Bom' },
      { descricao: 'Bom' },
      { descricao: 'Médio' }
    ],
    editedItemCaixa: {
      descricao: '',
      fkEmpresa: 0,
      pkCaixa: 0,
      status: 0
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    }
  },
  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initialize()
  },

  methods: {
    async initialize () {
      try {
        this.progresso = true
        this.fornecedores = await axios
          .get('/ListagemCaixa')
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo
    async PesquisarDetalhesCaixa (pkCaixa) {
      try {
        this.progresso = true
        this.detalhes = await axios
          .get('/DetalhesCaixa/' + pkCaixa)
          .then(res => res.data)
        console.log(this.detalhes)
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // co
    async ItemsFactura (pkVenda) {
      try {
        this.progresso = true
        this.items_factura = await axios
          .get('/itemsFactura/' + pkVenda)
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async MovimentacoesCaixa (pkCaixa) {
      try {
        this.progresso = true
        this.movimentacoes = await axios
          .get('/movimentacoesCaixa/' + pkCaixa)
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // co

    VerItemsVenda (item) {
      this.dialog_items = true
      this.ItemsFactura(item.fkVenda)
    },
    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    EditarFornecedor (item) {
      this.editedItem = Object.assign(this.editedItem, item)
      this.dialog = true
    },
    DetalhesCaixa (item) {
      this.pkCaixa = item.pkCaixa
      this.PesquisarDetalhesCaixa(item.pkCaixa).then(() => {
        this.MovimentacoesCaixa(item.pkCaixa).then(() => {
          this.editedItemCaixa = Object.assign(this.editedItemCaixa, item)
          this.dialog_detalhes = true
        })
      })
    },
    saveDataVencimento (date) {
      this.$refs.menuVencimento.save(date)
      this.dataVencimento = date
      this.pesquisar(date)
    },
    async pesquisar (data) {
      this.MovimentacoesCaixaData(data)
    },
    async MovimentacoesCaixaData (data) {
      try {
        this.progresso = true
        this.movimentacoes = await axios
          .get('/movimentacoesCaixaData/' + this.pkCaixa + '/' + data)
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    } // co
  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}

</style>
